export class SubscriptionDetails {
	constructor(subscriptionDetails) {
		this.ratePlanOrderId = subscriptionDetails.ratePlanOrderId;
		this.sellerOrganizationId = subscriptionDetails.sellerOrganizationId;
		this.sellerOrganizationName =
			subscriptionDetails.sellerOrganizationName;
		this.buyerOrganizationId = subscriptionDetails.buyerOrganizationId;
		this.buyerOrganizationName = subscriptionDetails.buyerOrganizationName;
		this.ownerOrganizationId = subscriptionDetails.ownerOrganizationId;
		this.ownerOrganizationName = subscriptionDetails.ownerOrganizationName;
		this.ratePlanDetails = {
			type: subscriptionDetails.ratePlanDetails.type,
			ratePlan: subscriptionDetails.ratePlanDetails.ratePlan,
			durationMonths: subscriptionDetails.ratePlanDetails.durationMonths,
			addons: subscriptionDetails.ratePlanDetails.addons,
			options: subscriptionDetails.ratePlanDetails.options,
			range: subscriptionDetails.ratePlanDetails.range
		};
		this.endDate = subscriptionDetails.status?.endDate;
		this.description = subscriptionDetails.description;
		this.extensions = subscriptionDetails.extensions;
		this.sLabel = subscriptionDetails.sLabel;
		this.maxDataPoints = subscriptionDetails.maxDataPoints;

		if (subscriptionDetails.ratePlanDetails.config) {
			this.ratePlanDetails.config = {
				displayName:
					subscriptionDetails.ratePlanDetails.config.displayName,
				numberOfDataPointsPer10Minutes:
					subscriptionDetails.ratePlanDetails.config
						.numberOfDataPointsPer10Minutes,
				numberOfAdditionalDataPointsPer10Minutes:
					subscriptionDetails.ratePlanDetails.config
						.numberOfAdditionalDataPointsPer10Minutes,
				propertiesMaxNumber:
					subscriptionDetails.ratePlanDetails.config
						.propertiesMaxNumber,
				ratePlanDeviceType:
					subscriptionDetails.ratePlanDetails.config
						.ratePlanDeviceType,
				authorizedProtocols:
					subscriptionDetails.ratePlanDetails.config
						.authorizedProtocols,
				propertiesLimitByTransmission:
					subscriptionDetails.ratePlanDetails.config
						.propertiesLimitByTransmission,
				frequency: subscriptionDetails.ratePlanDetails.config.frequency
			};
		}
	}
}
